/** @format */

import {configureStore} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import {combineReducers} from 'redux'
import storage from 'redux-persist/lib/storage'
//components
import quickSmsReducer from './FrontEnd/QuickMessageSlice/QuickSmsSlice'
import quickMmsReducer from './FrontEnd/QuickMessageSlice/quickMmsSlice'
import changePasswordReducer from './FrontEnd/AuthSlices/ChangePasswordSlice'
import refreshTokenReducer from './FrontEnd/AuthSlices/ChangePasswordSlice'
import signUpReducer from './FrontEnd/AuthSlices/SignUpSlice'

import ChangeEmailReducer from './FrontEnd/AuthSlices/ChangeEmailSlice'
import loadingSlice from './FrontEnd/Loading/LoadingSlice'
import {loadingSlice as loadingGlobal} from './FrontEnd/Loading/LoadingSlice'
import ProDashboardSlice, {proDashboardSlice} from './FrontEnd/ProDashboardSlices/ProDashboardSlice'
import UpdateProfileReducer from '../pages/UserPages/accounts/Overview/OverviewSlice/UpdateProfileSlice'
import TeamListSlice from '../pages/UserPages/accounts/Overview/OverviewSlice/TeamListSlice'
import userDeatailsReducer from '../pages/UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'

import ForgotPasswordReducer from './FrontEnd/AuthSlices/ForgotPasswordSlice'
import BusinessName from '../pages/UserPages/accounts/BusinessName/BusinessNameSlice/BusinessSlice'
import Notification from './FrontEnd/NotificationSlice/NotificationSlice'

import Comment from './AdminPanel/CommentSlice'
import Quickmsg from './AdminPanel/QuickMessageSlice'
import AssignUser from './AdminPanel/AssignUserSlice'
import ProductList from './AdminPanel/PurchaseCreditSlice'

import AdminAuth from './AdminPanel/AdminAuthSlice'
import AdminProfile from './AdminPanel/AccountModuleSlice/AdminProfileSlice'
import UserBilling from '../pages/UserPages/accounts/Billing/BillingSlice/BillingSlice'
import ProfileDetailDataOfUser from './AdminPanel/ProfileDetailsSlice'
import getAllGiphy from '../pages/Common/GiphyPopup/GiphySlice/GiphySlice'
import CustomNumber from '../pages/UserPages/accounts/CustomNumber/CustomNumberSlice/CustomNumberSlice'

import Subscriber from '../pages/UserPages/Contacts/AllContactsList/SubscriberSlice/SubscriberSlice'
import SegmentData from '../pages/UserPages/Contacts/Segments/SegmentSlice/SegmentSlice'
import TagName from '../pages/UserPages/Contacts/Tags/TagSlice/TagsSlices'
import OptoutList from '../pages/UserPages/Opt_out/OptoutSlice/OptoutListSlice'
import BaseTagName from '../pages/AdminPages/Templates/Tags/TagSlice/TagsSlices'

import UserAccount from '../pages/AdminPages/AllCellCastUser/UserListSlice/UserListSlice'
import UserAccountSmartSms from '../pages/AdminPages/AllSmartSmsUser/UserListSlice/UserListSlice'

import StaffAccount from '../pages/AdminPages/MyProfile/Staff_Account/StaffAccountSlice/StaffAccountSlice'

///////////////////////////USER ProfileDetail/////////////////////////////
import AssignedStaff from '../pages/AdminPages/AllCellCastUser/UserProfileDetail/UserProfileDetailSlice/UserProfileDetailSlice'

/////////////////////////////STAFF PROFILE DETAIL///////////////////
import AssignedUser from '../pages/AdminPages/MyProfile/Staff_Account/StaffProfileDetail/StaffProfileDetailSlice/StaffProfileDetailSlice'

import DedicatedNumber from '../pages/AdminPages/DedicatedNumber/DedicatedNumberSlice/DedicatedNumberSlice'
import PriceRules from '../pages/AdminPages/Setup/GlobalRateCard/GlobalRateCardSlice/GlobalRateCardSlice'
import Gateway from '../pages/AdminPages/GatewayManagement/GatewayManagementSlice/GatewayManagementSlice'

//////////////////////////////////////////////FrontendSLICEs////////
import ownerDedicatedNumberSlices from '../pages/UserPages/accounts/DedicatedNumber/DedicatedNumberSlice/DedicatedNumberSlice'
import UserLoginSlice from '../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'

import OurTemplateSlice from '../pages/UserPages/MyTemplate/OurTemplates/OurTemplateSlice/OurTemplateSlice'
import TemplateSlice from '../pages/UserPages/MyTemplate/CreateScratch/CreateScratchSlices/CreateScratchSlices'

import InboxDataOld from '../pages/UserPages/inbox/InboxSlice/InboxSlice'
import InboxData from '../pages/UserPages/inbox-v2/InboxSlice/InboxSlice'

import LandingPage from '../pages/UserPages/LandingPage/LandingPageSlice/LandingPageSlice'
import ShortLink from '../pages/UserPages/reports-analytics/ShortLinkSlice/ShortLinkSlice'
import WhiteLabelSlice from '../pages/AdminPages/WhiteLabel/WhiteLabelSlice/WhiteLabelSlice'
import AdminOptoutList from '../pages/AdminPages/Setup/Opt_out/OptoutSlice/OptoutListSlice'
import GlobalSettingSlice from '../pages/AdminPages/Setup/GlobalSetting/GlobalSettingSlice/GlobalSettingSlice'
import WhiteLAbelUser from '../pages/AdminPages/WhiteLabel/WhiteLabelProfile/WhiteLabelProfileSlice/WhiteLAbelSlice'
import BulkMessageData from '../pages/UserPages/new-message/BulkMessageSlice/BulkMessageSlice'
import reportAnalyticsSlice from '../pages/UserPages/reports-analytics/reportSlices/reportAnalytics'
import EndUserSlice from '../pages/UserPages/EndUserPages/EndUserSlice/EndUserSlice'
import FirstMessageApproval from '../pages/AdminPages/FirstMessageAprroval/FirstMessageApprovalSlice'
import emailToSMS from '../pages/UserPages/EmailToSms/EmailToSmsSlice/EmailToSmsSlice'
import ApiKeys from '../pages/UserPages/accounts/ApiKeys/ApikeysSlices/ApiKeysSlices'
import FEDashboardData from '../pages/UserPages/dashboard/FrontEndDashboardSlice/FrontendDashboardSlice'
import BEDashboardData from '../pages/AdminPages/dashboard/BackendDashboardSlice/BackendDashboardSlice'
import popupReducer from '../Components/PopupSlice/popupSlice'
import AutomationSlice from '../pages/UserPages/automation/automationSlice/AutomationSlice'
import IntegrationSlice from '../pages/UserPages/Integration/IntegrationSlice/IntegrationSlice'
import {cellcastApi} from '../../services/cellcast'
import {cellcastV2Api} from '../../services/cellcast.v2'
import {cellcastV3Api} from '../../services/cellcast.v3'

import loadingSendSlice from './FrontEnd/Loading/LoadingSendSlice'

import {loadingSendSlice as loadSendSlice} from './FrontEnd/Loading/LoadingSendSlice'
import FlowDraftReducer from './FrontEnd/FlowDraftSlice'

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['cellcastApi', 'cellcast_api_v2', 'cellcast_api_v3'],
}

const data = combineReducers({
  //////////////USER AND ADMIN LOGIN SLICES////////////////////////////////
  UserSignIn: UserLoginSlice,

  /////////////////////////////////////Admin////////////////////////////////////////
  UserAccount: UserAccount,
  UserAccountSmartSms: UserAccountSmartSms,
  StaffAccount: StaffAccount,
  reportAnalytics: reportAnalyticsSlice,
  BackendDashboard: BEDashboardData,

  ////////////////////////////////////////////////////UserProfileDetail/////////////////////////////////
  AssignedStaff: AssignedStaff,
  FirstMessageApprovalData: FirstMessageApproval,
  //////////////////////////////////////////////////////////STAFF PROFILE DETAILE///////////////////////
  AssignedUser: AssignedUser,

  dedicatedNumber: DedicatedNumber,
  priceRules: PriceRules,
  paymentGateway: Gateway,
  //////////////////////////////////////WhiteLABLE PROFILE////////////////////
  WhiteLabelUser: WhiteLAbelUser,
  ///////////////////////////////////////////////////////FRONTEND///////////////////////////////////////
  ownerDedicatedNumbers: ownerDedicatedNumberSlices,
  Giphy: getAllGiphy,
  emailToSMS: emailToSMS,
  GlobalSettingSlice: GlobalSettingSlice,
  userDetails: userDeatailsReducer,
  quickSms: quickSmsReducer,
  quickMms: quickMmsReducer,
  changePassword: changePasswordReducer,
  refreshToken: refreshTokenReducer,
  signUp: signUpReducer,

  changeEmail: ChangeEmailReducer,
  loading: loadingSlice,
  loadingSend: loadingSendSlice,
  updateProfile: UpdateProfileReducer,

  forgotPassword: ForgotPasswordReducer,
  comment: Comment,
  businessName: BusinessName,
  quickMsg: Quickmsg,
  assignList: AssignUser,
  teamlist: TeamListSlice,

  productList: ProductList,

  notification: Notification,
  AdminAuth: AdminAuth,
  AdminProfile: AdminProfile,
  ProfileData: ProfileDetailDataOfUser,
  PurchaseHistory: UserBilling,

  CustomNumber: CustomNumber,
  subscriberData: Subscriber,
  SegmentData: SegmentData,
  tags: TagName,
  baseTags: BaseTagName,

  //////////////////////////////////////FRONTEND STATE////////////////////////////////////////
  FEDashboard: FEDashboardData,

  ////MY TEMPLATE////////
  ourTemplate: OurTemplateSlice,
  Template: TemplateSlice,

  apikeys: ApiKeys,

  ///////////////////INBOX///////////////////
  InboxDataOld: InboxDataOld,
  InboxData: InboxData,

  //////LAnding page////////////
  LandingPage: LandingPage,
  ShortLink: ShortLink,
  //////sOPTOUT LIST/////
  optoutList: OptoutList,
  adminoptoutList: AdminOptoutList,

  //////////////////////////////////////////////WhiteLABEl//////////////////
  whiteLabelList: WhiteLabelSlice,

  //////////////////////////Bulk Message////////////////////
  bulkMessageData: BulkMessageData,
  /////////////////////////////
  endUserData: EndUserSlice,

  //////////////////////////
  popup: popupReducer,

  //////////////////////////
  automation: AutomationSlice,

  // Integration page
  integration: IntegrationSlice,

  proDashboard: ProDashboardSlice,
  flowDraft: FlowDraftReducer,

  [cellcastApi.reducerPath]: cellcastApi.reducer,
  [cellcastV2Api.reducerPath]: cellcastV2Api.reducer,
  [cellcastV3Api.reducerPath]: cellcastV3Api.reducer,
})

const restApp = (state: any, action: any) => {
  if (action.type === 'reset') {
    localStorage.clear()
    storage.removeItem('persist:root')
    return data(undefined, action)
  }
  if (action.type === 'resetRedux') {
    storage.removeItem('persist:root')
    return data(undefined, action)
  }
  return data(state, action)
}

export const reset = () => {
  return {
    type: 'reset',
  }
}

export const resetRedux = () => {
  return {
    type: 'resetRedux',
  }
}

const persistedReducer = persistReducer(
  {
    ...persistConfig,
    blacklist: [
      cellcastApi.reducerPath,
      cellcastV2Api.reducerPath,
      cellcastV3Api.reducerPath,
      loadSendSlice.name,
      loadingGlobal.name,
      proDashboardSlice.name,
    ],
  },
  restApp
)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => {
    const middleware = getDefaultMiddleware()
    return middleware
      .concat(cellcastApi.middleware)
      .concat(cellcastV2Api.middleware)
      .concat(cellcastV3Api.middleware)
  },
})
